import $ from "jquery"
window.jQuery = $
window.$ = $


import BBDO_Form from './modules/form'
import BBDO_Select from './modules/select'
import BBDO_Share from './modules/share'
import Navigation from './modules/navigation'

import Account from './views/account'
import Brand from './views/brand'
import Newsletter from './views/newsletter'
import Product from './views/product'
import Recipe from './views/recipe'
import Recipes from './views/recipes'
import Search from './views/search'


/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const readCookie = function (name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  let i = 0;
  while (i < ca.length) {
    let c = ca[i];
    while (c.charAt(0) === " ") { c = c.substring(1, c.length); }
    if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length, c.length).replace(/"/g, ''); }
    i++;
  }
};

const setCookie = function (cookieName, cookieValue) {
  const today = new Date();
  const expire = new Date("2018-01-01 12:00:00");
  if (location.protocol === "https:") {
    return document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString() + ";secure";
  } else {
    return document.cookie = cookieName + "=" + escape(cookieValue) + ";expires=" + expire.toGMTString();
  }
};

if (window.BBDO == null) {
  window.BBDO = {
    Events: {},
  };
}

const Cls = (BBDO.Site = class Site {
  static initClass() {
    this.prototype.current_page = null;
    this.prototype.$el = null;
    this.prototype.animating = false;
  }

  constructor($el) {
    this.open_search = this.open_search.bind(this);
    this.resizeHandler = this.resizeHandler.bind(this);
    this.$el = $el;
    this.route(this.$el.data('page'));
    this.init_events();
  }

  init_events() {

    //click event overlay modal
    $('.modalDialog').on('click', e => window.location.hash = 'close');

    $('.modalDialog__popup').on('click', e => e.stopPropagation());

    $('.modalDialog .modalClose').on('click', function (e) {

      return $(this).closest('.modalDialog').removeClass('open');
    });

    if ($('#showmore').length && ($('#showmore').val() !== '1')) {
      $('.load-more__button').hide();
      $('#showmore').remove();
    }

    //click event on show more/less banner
    $('.js-toggle-content').on('click', this.toggle_content);

    //if notification is set, remove after few seconds
    if ($('.notification:not(.dont_autoclose)')[0]) {
      setTimeout((() =>
        $('.notification:not(.dont_autoclose)').slideUp(function () {
          return $(this).remove();
        })
      ), window.site.notification_time);
    }

    $('.load-more__button').on('click', function (e) {

      $('.loader').css('visibility', 'visible');

      const button = $(this);
      const page = parseFloat($(this).attr('data-page')) + 1;
      const content = $(this).data('content');
      $('.load-more__button').show();

      const recipetype = $("select[name='recipetype']").val();
      const dishtype = $("select[name='dishtype']").val();
      const cooktime = $("select[name='cooktime']").val();
      const popular = $("select[name='popular']").val();

      const url = window.site.base_url + '/api/contentbypage';

      return $.ajax({
        type: 'GET',
        url,
        data: {
          page,
          content,
          recipetype,
          dishtype,
          cooktime,
          popular
        },
        success: data => {

          $('.loader').css('visibility', 'hidden');

          if (!data) {
            return button.parent().hide();
          } else {
            $('.load-more__button').attr('data-page', page);

            const elements = jQuery(data);

            if (elements.last()[0].value === '1') {
              button.parent().show();
            } else {
              button.parent().hide();
            }

            elements.splice(-1, 1);
  
            return $(".news-grid").append(elements)
              .masonry('appended', elements, true);
          }
        },


        error(xhr, textStatus, error) {
          console.log(xhr.statusText);
          console.log(textStatus);
          return console.log(error);
        }
      });
    });

    $('body').on('scroll', e => {
      return console.log('scroll');
    });


    //event for print button
    $('.js-print').on('click', function (e) {
      e.preventDefault();
      return window.print();
    });

    //event for custom file upload field
    $('input[type="file"]').each(function () {
      const $input = $(this);
      const $label = $input.next('label');
      const labelVal = $input.next('label').html();
      return $input.on('change', function (e) {
        let fileName = '';

        if (e.target.value) {
          fileName = e.target.value.split('\\').pop();
        }

        if (fileName) {
          return $label.addClass('is-filled').html(fileName);
        } else {
          return $label.removeClass('is-filled').html(labelVal);
        }
      });
    });

    //event for closing notification
    $('.js-close-notification').on('click', function (e) {
      e.preventDefault();
      return $(this).parent().slideUp(200);
    });

    //events for search toolbar
    $('.js-open-search').on('click', e => {
      if ($('.nav-links').css('position') !== 'fixed') {
        e.preventDefault();
        this.close_login();
        return this.open_search();
      }
    });

    $('.js-close-search').on('click', e => {
      e.preventDefault();
      return this.close_search();
    });

    //event for headers
    /*if($('.header.big')[0])
      colorThief = new ColorThief()
        colors = colorThief.getColor($('.header.big img')[0])
        r = colors[0]
        g = colors[1]
        b = colors[2]
        $('.header.big .header__image__wrapper').css('background-color', 'rgb(' + r + ',' + g + ',' + b + ')')*/

    //global resize handler
    $(window).on('resize', this.resizeHandler);
    return this.resizeHandler();

    /*if($('.header--video')[0])
      @initVideo()



  initVideo:  ->
    iframe = $('#vimeoplayer')[0]
    player = $(iframe)

    player.addEvent 'ready', ->
      console.log('ready')
      player.api('play')
      $('.header--video .header__image__wrapper').css('opacity', 0)

  */
  }

  toggle_content(e) {
    e.preventDefault();
    const target = $(this).attr('data-toggle');

    $(`.${target}`).stop().slideToggle(200);
    $(this).toggleClass('is-open');

    if ($(this).hasClass('is-open') && $(this)[0].hasAttribute("data-hide") && $(this)[0].hasAttribute("data-show")) {
      return $('.banner__text').text($(this).attr('data-hide'));
    } else {
      return $('.banner__text').text($(this).attr('data-show'));
    }
  }

  open_search() {
    if ($('.search-bar').css('display') !== "none") {
      $('.search-bar').addClass('is-open');
      return $('body').addClass('has-padding');
    }
  }

  close_search() {
    if ($('.search-bar').css('display') !== "none") {
      $('.search-bar').removeClass('is-open');
      if (!$('.user-sidebar').is(':visible')) {
        return $('body').removeClass('has-padding');
      }
    }
  }

  resizeHandler(e) {
    const elem = $('.content > div:not(.user-sidebar):not(.footer):not(.news-grid)');
    elem.css('height', 'auto');
    const windowHeight = $(window).outerHeight();
    const navHeight = $('.nav').outerHeight();
    const contentHeight = $('.content').outerHeight();
    const footerHeight = $('.footer').outerHeight() + $('.subfooter').outerHeight();

    //check if there is white space below footer, if so then make content larger
    if ((navHeight + contentHeight) < windowHeight) {
      const newHeight = windowHeight - navHeight - footerHeight - (parseInt(elem.css('padding-top'), 10)) - (parseInt(elem.css('padding-bottom'), 10));
      return $('.content > div:not(.user-sidebar):not(.footer)').height(newHeight);
    }
  }

  route(page) {
    console.log(page);

    switch (page) {
      case 'product':
        return this.current_page = new Product();
      case 'brand':
        return this.current_page = new Brand();
      case 'productdetail':
        return this.current_page = new Product();
      case 'recipedetail':
        return this.current_page = new Recipe();
      case 'recipes':
        return this.current_page = new Recipes();
      case 'account':
        return this.current_page = new Account();
      case 'newsletters':
        return this.current_page = new Newsletter();
      case 'search':
        return this.current_page = new Search();
      case 'index':
        //return this.current_page = new BBDO.Index();
        return this.current_page = new Recipes();
    }
  }
});
Cls.initClass();



$(document).ready(function () {
  window.site.app = new BBDO.Site($('body'));

  $('.select').each(function () {
    let select;
    return select = new BBDO_Select($(this));
  });

  $('form:not(.account-form):not(.search-form)').each((index, element) => {
    return new BBDO_Form($(element));
  });

  $('.js-share').each((index, element) => {
    return new BBDO_Share($(element));
  });

  let nav = new Navigation(document.querySelector('header.nav'), document.querySelector('.menu-panel'));



  // tracking
  $(document).on("click", "a[href]", function (e) {
    /*href = $(this).prop "href"
    to_frame = $(this).prop("target") == '_blank'
    root = window.location.protocol + "//" + window.location.host

    if href.slice(0, root.length) != root
      e.preventDefault() unless to_frame

      ga(
        'send',
        'event',
        'outbound',
        'click',
        href,
        {
          'hitCallback': () =>
            unless to_frame
              document.location = href
        }
      )

      false unless to_frame*/}
  );

  if ($('.news-grid:not(.has-nocontent)')[0]) {
    return $('.news-grid').masonry({
      itemSelector: '.news-item',
      columnWidth: '.news-item',
      percentPosition: true
    });
  }
});
